import { useState } from "react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("/api/check-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      const result = await res.json();
      setLoading(false);

      if (!res.ok || !result.authorized) {
        setError("❌ That email isn't authorized.");
        return;
      }

      localStorage.setItem("cubble-email", email.trim().toLowerCase());
      window.location.href = "/links";
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError("⚠️ Something went wrong. Please try again.");
    }
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{
        background: "radial-gradient(ellipse at 50% 20%, #232a37 0%, #2a2443 55%, #512f60 100%)",
      }}
    >
      <div className="w-full max-w-md bg-gray-900 shadow-2xl rounded-2xl p-8 border border-gray-700">
        <div className="text-center mb-8">
          <div className="text-3xl font-extrabold text-white tracking-tight mb-1">Internship Portal</div>
          <div className="text-base text-blue-300 font-semibold mb-1">by Cubble</div>
          <div className="text-sm text-gray-400 mb-3">
            Please sign in with your registered email to access resources.
          </div>
        </div>
        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <label className="text-base font-medium text-gray-300 text-left">Email</label>
          <input
            type="email"
            className="border border-gray-700 bg-gray-800 text-white rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-gray-400"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            autoFocus
          />
          <button
            type="submit"
            className={`mt-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg py-3 transition disabled:opacity-50`}
            disabled={loading}
          >
            {loading ? "Checking..." : "Sign In"}
          </button>
          {error && <div className="text-red-400 text-center mt-2">{error}</div>}
        </form>
      </div>
      <footer className="w-full max-w-md text-center text-xs text-gray-500 mt-10 mb-4">
        Internship Portal &copy; {new Date().getFullYear()} | Cubble
      </footer>
    </div>
  );
}
